import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Home from "./pages/Home";
import About from "./pages/about/About";
import Whatwedo from "./pages/Whatwedo";
import Team from "./pages/team/Team";
import OtherTeamMembers from "./pages/team/otherTeam";
// import Products from "./pages/products/Products";
import Claim from "./pages/claim/Claim";
import Reportclaim from "./pages/claim/Reportclaim";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import BoardOfDirectors from "./pages/team/BoardofDirectors";
import BackgroundMusic from "./components/music/BackgroundMusic";
import musicFile from "./assets/music/wonderful-world.mp3";
import NotFound from "./pages/notfound/NotFound";
import FAQS from "./components/faqs/FAQs";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";
import CookiePolicy from "./pages/privacy/CookiePolicy";
import TermsAndConditions from "./pages/privacy/TermsAndConditions";
import {
  Engineering,
  Liability,
  Life,
  Property,
  Motor,
  Pecuniary,
  Travel,
  SpecialtyLines,
} from "./pages/product/index";
import Products from "./pages/products/Products";
import Cursor from "./components/Cursor";
import CookieConsentBanner from "./components/cookie/CookieConsent";
import FloatingButtons from "./components/FloatingButtons";
import InsuranceBlog from "./pages/blog/Blog";
import InsuranceBlogPost from "./pages/blog/BlogPost";
import ContentGuard from "./components/content-admin/ContentGuard";
import ContentAdmin from "./components/content-admin/ContentAdmin";
import ContentLogin from "./components/content-admin/ContentLogin";
import Login from "./components/login/Login";


const App = () => {
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isStandaloneRoute =
    normalizedPath === "/get-started" ||
    normalizedPath === "/content-login" ||
    normalizedPath === "/content-admin" ||
    normalizedPath.startsWith("/content-admin/");

  useEffect(() => {
    AOS.init({
      duration: 1500,
      easing: "ease-in",
      once: false,
    });
  }, []);

  return (
    <div className="App bg-light">
      {!isStandaloneRoute && <Cursor />}
      {!isStandaloneRoute && <Navbar />}
      {!isStandaloneRoute && <BackgroundMusic src={musicFile} />}
      <div className={isStandaloneRoute ? "" : "fade"}>
        <Routes>
          <Route index exact path="/" element={<Home />} />
          <Route exact path="/who-we-are" element={<About />} />
          <Route exact path="/what-we-do" element={<Whatwedo />} />
          <Route exact path="/cookie-policy" element={<CookiePolicy />} />
          <Route
            exact
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/faqs" element={<FAQS />} />
          <Route exact path="/blog" element={<InsuranceBlog />} />
          <Route exact path="/blog/:slug" element={<InsuranceBlogPost />} />
          <Route exact path="/get-started" element={<Login />} />
          <Route exact path="/content-login" element={<ContentLogin />} />
          <Route
            path="/content-admin/*"
            element={
              <ContentGuard>
                <ContentAdmin />
              </ContentGuard>
            }
          />
          <Route exact path="/our-products" element={<Products />} />

          <Route
            exact
            path="/board-of-directors"
            element={<BoardOfDirectors />}
          />
          <Route exact path="/management-team" element={<Team />} />
          <Route
            exact
            path="/other-team-members"
            element={<OtherTeamMembers />}
          />
          <Route exact path="/claim" element={<Claim />} />
          <Route exact path="/report-a-claim" element={<Reportclaim />} />
          <Route
            exact
            path="/products/life&personal-insurance"
            element={<Life />}
          />
          <Route
            exact
            path="/products/engineering-insurance"
            element={<Engineering />}
          />
          <Route exact path="/products/travel-insurance" element={<Travel />} />
          <Route
            exact
            path="/products/pecuniary-insurance"
            element={<Pecuniary />}
          />
          <Route
            exact
            path="/products/property-insurance"
            element={<Property />}
          />
          <Route
            exact
            path="/products/liability-insurance"
            element={<Liability />}
          />
          <Route exact path="/products/motor-insurance" element={<Motor />} />
          <Route
            exact
            path="/products/specialty-lines"
            element={<SpecialtyLines />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isStandaloneRoute && <Footer />}
      {!isStandaloneRoute && <FloatingButtons />}
      {!isStandaloneRoute && <CookieConsentBanner />}
    </div>
  );
};

export default App;
